<template>
  <div>
    <vue-c3 :handler="handler"></vue-c3>
  </div>
</template>

<script>

import Vue from 'vue';
import VueC3 from 'vue-c3';
import * as d3 from 'd3';
require('c3/c3.css');

export default {
  name: 'VibeBatteryChart',
  components: {
    VueC3
  },
  props: {
    vibeBattery: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      handler: new Vue(),
      names: {},
      vibeValues: {
        greenVibe: 83.5,
        orangeVibe: 48.5,
        redVibe: 16.5
      },
      colors: [
        '#ffa138'
      ]
    };
  },
  watch: {
    vibeBattery: {
      handler: function () {
        this.draw();
      }
    }
  },
  mounted () {
    this.draw();
  },
  computed: {
    getFilteredVibeBattery () {
      let filteredVibeBattery = this.vibeBattery.filter(item => item.value !== null && item.value !== '');
      return filteredVibeBattery.map(item => {
        let vibeValue = null;
        if (item.value === 'GreenVibe') {
          vibeValue = this.vibeValues.greenVibe;
        }
        if (item.value === 'OrangeVibe') {
          vibeValue = this.vibeValues.orangeVibe;
        }
        if (item.value === 'RedVibe') {
          vibeValue = this.vibeValues.redVibe;
        }
        return {
          timestamp: item.timestamp,
          value: vibeValue
        };
      });
    }
  },
  methods: {
    draw () {
      const options = {
        data: {
          x: 'x',
          xFormat: '%Y-%m-%dT%H:%M:%S.%LZ',
          columns: [
            ['x', ...this.getFilteredVibeBattery.map(item => item.timestamp)],
            ['VibeBattery', ...this.getFilteredVibeBattery.map(item => item.value)]
          ]
        },
        color: {
          pattern: this.colors
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              rotate: -30,
              multiline: false,
              format: function (x) {
                let formatSeconds = d3.time.format('%d-%m');
                return formatSeconds(new Date(x * 1000));
              }
            },

            height: 50
          },
          y: {
            tick: {
              format: function () { return ''; }
            },
            max: 100,
            min: 0,
            padding: { top: 0, bottom: 0 }
          }
        },
        regions: [
          {axis: 'y', start: 0, end: 33, class: 'regionYRed', opacity: 0.2},
          {axis: 'y', start: 33, end: 66, class: 'regionYOrange', opacity: 0.2},
          {axis: 'y', start: 66, end: 100, class: 'regionYGreen', opacity: 0.2}
        ],
        legend: {
          show: false
        },
        tooltip: {
          contents: (d) => {
            let formatSeconds = d3.time.format('%Y-%m-%d');
            const date = formatSeconds(new Date(d[0].x * 1000));
            let vibeBattery = 'GreenVibe';
            if (d[0].value === this.vibeValues.orangeVibe) {
              vibeBattery = 'OrangeVibe';
            }
            if (d[0].value === this.vibeValues.redVibe) {
              vibeBattery = 'RedVibe';
            }
            return `<div class='c3-tooltip-container custom-tooltip'>
             <table class='c3-tooltip'>
             <tbody>
                <tr>
                    <th colspan='2'>${date}</th>
                </tr>
                <tr>
                  <td class="value">
                      ${vibeBattery}
                  </td>
                </tr>
               </tbody>
               </table>
              </div>`;
          }
        }
      };
      this.handler.$emit('init', options);
    }
  }
};
</script>

<style lang="scss">
@import "src/stylesheets/variables";

.regionYRed {
  fill: #ff0000;
}

.regionYOrange {
  fill: #ffa716;
}

.regionYGreen {
  fill: #20ea20;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/summary/VibeBatteryChart.vue